export default __webpack_public_path__ + "static/media/PinkFrame01.ffb8d899.png";